import * as yup from "yup";
export const PasswordResetValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Enter a valid work email")
    .required("Your Work email is required"),
});

export const AccountRequestValidationSchema = yup.object().shape({
  firstname: yup.string().required("Your First Name is required"),
  lastname: yup.string().required("Your Last Name  is required"),
  email: yup
    .string()
    .email("Please enter a valid work email")
    .required("Your Work email is required"),
  departmentId: yup.number().required("Your department is required"),
  jobfunction: yup.string().required("Your Job Title is required"),
});

export const LoginValidationSchema = yup.object().shape({
  username: yup
    .string()
    .email("Please enter a valid work email")
    .required("Your Work email is required"),

  password: yup.string().required("Your secured password is required"),
});

